/* eslint-disable prettier/prettier */
import { cilAlignCenter } from '@coreui/icons'
import { useLocation, Navigate, Outlet } from 'react-router-dom'
import useAuth from '../hooks/useAuth'

// eslint-disable-next-line react/prop-types
const RequireAuth = ({ allowedRoles }) => {
    const { auth } = useAuth()
    const location = useLocation()
    console.log('allowedRoles', allowedRoles);
    console.log('auth', auth.roles);
    return (
        // eslint-disable-next-line react/prop-types
        auth?.roles?.find(role => allowedRoles?.includes(role.label))
            // eslint-disable-next-line react/react-in-jsx-scope
            ? <Outlet />
            : auth?.user
                // eslint-disable-next-line react/react-in-jsx-scope
                ? <Navigate to="/unauthorized" state={{ from: location }} replace />
                // eslint-disable-next-line react/react-in-jsx-scope
                : <Navigate to="/login" state={{ from: location }} replace />
    );
}
export default RequireAuth